import React, { useEffect, useState } from "react";
import {
  Card, Switch, Table, Tag, Typography, Spin, Space, Button, message,
} from "antd";
import { ReloadOutlined, CheckCircleOutlined } from "@ant-design/icons";
import axios from "axios";

const { Title, Text } = Typography;
const API_URL = process.env.REACT_APP_API_URL;

export default function FrmGestionProduccion() {
  const [vacas, setVacas] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [cambiando, setCambiando] = useState({});

  const cargar = async () => {
    try {
      setCargando(true);
      const resp = await axios.get(`${API_URL}/Animal`, {
        params: { sexo: "Hembra", estado: "Activo", pagina: 1, tamañoPagina: 200 },
      });
      const lista = Array.isArray(resp.data?.lista?.$values)
        ? resp.data.lista.$values
        : Array.isArray(resp.data?.lista)
        ? resp.data.lista
        : [];
      setVacas(lista);
    } catch {
      message.error("Error cargando animales.");
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const toggleProduccion = async (animal, valor) => {
    setCambiando(prev => ({ ...prev, [animal.id]: true }));
    try {
      await axios.patch(`${API_URL}/Animal/${animal.id}/produccion`, valor, {
        headers: { "Content-Type": "application/json" },
      });
      setVacas(prev =>
        prev.map(v => v.id === animal.id ? { ...v, enProduccion: valor } : v)
      );
      message.success(`${animal.nombre || animal.arete} — ${valor ? "En producción ✅" : "Fuera de producción"}`);
    } catch {
      message.error("No se pudo actualizar. Verifique que el backend esté corriendo.");
    } finally {
      setCambiando(prev => ({ ...prev, [animal.id]: false }));
    }
  };

  const enProduccion = vacas.filter(v => v.enProduccion).length;

  const columns = [
    {
      title: "Arete",
      dataIndex: "arete",
      key: "arete",
      width: 100,
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      render: v => v || <Text type="secondary">Sin nombre</Text>,
    },
    {
      title: "Raza",
      dataIndex: "razaNombre",
      key: "razaNombre",
      responsive: ["md"],
      render: v => v || "—",
    },
    {
      title: "Etapa",
      dataIndex: "etapaProductivaCache",
      key: "etapa",
      responsive: ["md"],
      render: v => v ? <Tag>{v}</Tag> : "—",
    },
    {
      title: "¿En producción / ordeño?",
      key: "enProduccion",
      width: 200,
      render: (_, record) => (
        <Space>
          <Switch
            checked={!!record.enProduccion}
            loading={!!cambiando[record.id]}
            onChange={val => toggleProduccion(record, val)}
            checkedChildren="Sí"
            unCheckedChildren="No"
          />
          {record.enProduccion
            ? <Tag color="green" icon={<CheckCircleOutlined />}>Ordeñando</Tag>
            : <Tag color="default">No ordeña</Tag>}
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 16 }}>
      <Title level={3}>Gestión de Vacas en Producción</Title>
      <Text type="secondary">
        Active el interruptor de las vacas que están siendo ordeñadas actualmente.
        Solo estas aparecerán en el formulario de <strong>Registro de Leche por Lote</strong>.
      </Text>

      <Card style={{ marginTop: 12, marginBottom: 16 }}>
        <Space size="large">
          <div>
            <Text type="secondary">Total hembras activas</Text>
            <div style={{ fontSize: 22, fontWeight: 600 }}>{vacas.length}</div>
          </div>
          <div>
            <Text type="secondary">En producción / ordeño</Text>
            <div style={{ fontSize: 22, fontWeight: 600, color: "#52c41a" }}>{enProduccion}</div>
          </div>
          <div>
            <Text type="secondary">Fuera de producción</Text>
            <div style={{ fontSize: 22, fontWeight: 600, color: "#8c8c8c" }}>
              {vacas.length - enProduccion}
            </div>
          </div>
          <Button icon={<ReloadOutlined />} onClick={cargar} loading={cargando}>
            Recargar
          </Button>
        </Space>
      </Card>

      <Spin spinning={cargando}>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={vacas}
          pagination={false}
          scroll={{ x: "max-content" }}
          size="middle"
          rowClassName={r => r.enProduccion ? "row-produccion" : ""}
        />
      </Spin>
    </div>
  );
}
